module.exports = {
  message: {
    //Building
    sy: "Home",
    wzzzwh: "Website Under Maintenance",
    //Bulletin
    gg: "Bulletin",
    //BulletinArticle
    wzmc: "Title",
    fbsj: "Updated",
    //DataPublic
    sjgk: "Statistics",
    fwgk: "Services",
    fwsl: "Services",
    ptlj: "Processed",
    hswj: "Surveys",
    j: "Cases",
    qj: "Thousand Cases",
    gzd3: "Most Concerned ",
    bjl: "Completed",
    mztb: "Weekly Reports",
    sll: "Totals",
    ydtb: "Monthly Reports",
    gfwmksl: "Cases Received Per Category",
    xh: "No.",
    fksj: "Time",
    fknr: "Contents",
    fwfl: "Service Category",
    cbdw: "Department",
    //Evaluate
    fwlx: "Service Category",
    wypj: "Comment",
    fwmk: "Sections",
    xzfwmk: "Service Category",
    fwfw: "Service Vicinity",
    xzfwfw: "Please select the applicable Vicinity",
    fwqy: "Service Location",
    xzfwqy: "Please select the applicable Location",
    cypj: "Comment",
    //HistoryFeedback
    lsfk: "Feedback History",
    lsh: "Reference No.",
    cljc: "Status",
    blz: "Processing",
    fhz: "Pending",
    //Home
    swzl: "LOST & FOUND",
    swzl1: "Lost&Found",
    benkexiuye: "Undergraduate",
    xzbz: "Find your lost items",
    dzdt: "MAP",
    jdmdd: "Destination ",
    txwjwshfwdf: "Rate our services by filling out this survey！",
    shsd: "Voice your concerns anywhere anytime",
    ssp: "Snapshots",
    rrcy: "Join us to build a better campus",
    zxkf: "Online Service",
    rgkfsj: "Available from 8:30 to 17:00",
    yzscx: "One-off Searches",
    wdfk: "Feedback",
    qnzs: "SJTUSU Rights",
    xgwzms: "Speak for the youth and let the good happen!",
    ymlr: "Service data at the palm of your hands",
    ggl: "Bulletin",
    tjl: "Submitted",
    fwfk: "Dealt Cases",
    jiedanliang: "Dealt Cases",
    slmyd: "Satisfactory Rating",
    gzd: "Most Concerned Topics",
    gradute: "Graduate Services",
    graduteinfo: "Graduate services",
    // index
    dl: "Login",
    tc: "Sign Out",
    htdl: "Admin",
    shfwrx: "Service Hotline",
    fdjjr: "Unavailable on public holidays",
    hjicp: "沪交ICP备20160031",
    bqsy: "Copyright © 2010 Shanghai Jiao Tong University",
    dzshs: "Address: 800 Dongchuan RD. Minhang District, Shanghai, China ",
    ybh: "Postal code: 200240",
    ch: "Phone",
    lalala1:
      "This platform only acts as a public service post and query charity platform for lost and found. Please follow the Honor Code and only publish authentic information. The platform does not assume any legal responsibility for the authenticity of the information, and reserves the right to delete any illegal information. Any dispute or loss arising or likely to arise from the information error shall be resolved by the parties through consultation.",
    // LostFind
    // addFindThing
    wdsl: "Item Lost",
    bt: "Title",
    srbt: "Please Insert Title",
    wplx: "Item Type",
    qxz: "Please select lost item type",
    dsxq: "Please Insert Description",
    bq: "Description",
    zdsr: "Max. 2 identifiers allowed (Optional)",
    dssj: "Date lost",
    xzzqsj: "Insert Approximate Time",
    dsdd: "Location Lost",
    srzqdd: "Insert Approximate Location",
    zpsc: "Upload Photos",
    zfmzp: "Notice: Upload photos of front and back of your student ID card.",
    zd3z: "Notice: Max. 3 photos allowed",
    kzxgh: "Student ID No.",
    srxgh: "Insert Student ID No.",
    lxfs: "Contact Info",
    srndsjh: "Phone No.",
    ly: "Additional Messages",
    wljkzh:
      "Please provide a complete description of the lost item (color, size, brand, etc.) and its pictures, if any, for better chance of retrieving your item.",
    tj: "Submit",
    swxxfbcg: "Item Info Submitted",
    ms: "Descriptions",
    gxwk: "Null",
    fh: "Back",
    wpxzxq: "Please Insert Description",
    zltj: "Featured lost items",
    zl: "Report Lost Item",
    wxts: "Friendly Reminder",
    lalala2:
      "Identity is verified on the platform, please post information by following the Honor Code. Please do not post information irrelevant to the lost property! Any disputes or loss arising or likely to arise from any information shall be resolved by negotiation between the parties. The information you filled in will only be displayed to campus students and teachers. We look forward to having your lost item returned soon!",
    zklyx: "Return",
    qrfb: "Submit ",
    // addWaitClaim
    wsdl: "Item Found",
    fbzlxx: "Release Found Information",
    sqxq: "Campus Found",
    sqsj: "Time Found",
    sqdd: "Location Found",
    lalala3:
      "Please provide a detailed description on the item found, including when and where, in order to increase the chances of it being returned to the owner. Do not disclose any sensitive information, such as the precise location of the goods found, publicly to unnecessary complications. Thank you for your cooperation.",
    lalala4:
      "Identity is verified on the platform, please post information by following the Honor Code. Please do not post information irrelevant to the lost property! Any disputes or loss arising or likely to arise from any information shall be resolved by negotiation between the parties. The information you filled in will only be displayed to campus students and teachers. We look forward to having your lost item returned soon!",
    // findInfo
    wfbdxx: "My Posts",
    wrldxx: "My Claims",
    xykh: "Student ID No.",
    zp: "Photos",
    zt: "Stat",
    rlsj: "Time Claimed",
    qrsj: "Time Confirmed",
    rlxx: "Claim Info",
    rnwsz:
      "If you are the owner, you may keep in touch with the finder via the contact information. This platform is Jaccount verified, please do not falsely claim!",
    ghwpsqrszsf:
      'To avoid false claims, please verify with the owner of the lost item, After returning the item, please change the status to "returned". Thank you for your kindness!',
    rlgwp: "Claim",
    qxfb: "Cancel",
    wpygh: "Returned",
    qrrlh:
      "After confirmation, you will be presented with the contact information of the finder, and your claim will be recorded on the platform. Please do not falsely claim.",
    wyrl: "Claim",
    schwfzh:
      "Message can not be retrieved after deletion, please delete with caution.",
    qr: "Confirm",
    rlcc: "Item claimed successfully",
    fbrdsjhm: "Contact:",
    jklxsqz: "please contact the Finder as soon as Possilbe",
    qygzzc:
      "This part is supported by Student Union,Thank You for Supporting Student Rights Services!",
    // findThing
    xzsw: "Items Lost",
    xz: "Found",
    yzh: "Returned",
    // index
    wxgdxx: "My Posts",
    hcss: "Press enter to search",
    qc: "Eliminate",
    ddrl: "Awaiting Claims",
    zsmynr: "File a claim!",
    sw: "Lose",
    // lostInfo
    jydqgzptxx:
      "Regular website visits recommended for efficient retrievals, once items are found, please click 'Item Returned'.",
    rnsdyswp:
      "If you have found the item stated, please inform the owner via direct contacts, this platform is verified through Jaccount",
    wpyzh: "Item Returned",
    wjdl: "Item Found",
    jklxsz:
      "Please contact the owner as soon as possible. Don't forget to confirm the identity of the owner when returning the items!",
    qrsqh:
      "After Confirmation, Contact informations of the owner will be provided, At the same time your confirmation record will be filed onto the platform. Thank your kindness.",
    sd: "Confirm",
    // minePublishInfo
    nhmyfbxx: "No Posts Yet",
    // waitClaim
    // Online
    xzkf: "Online Support",
    fwjjsx: "Coming soon",
    // ServicePublic
    // detail
    bjss: "Closed Date",
    bjhf: "Reply",
    zyx: "Like",
    // index
    // ServiceType
    srsjh: "Please Insert Phone No.",
    hqyzm: "Verify Here",
    sryzm: "Enter Code Here",
    qx: "Cancel",
    qd: "Confirm",
    // ShowData
    // Snapshot
    fklx: "Feedback type",
    xzfklx: "Select feedback type",
    fwbk: "Service Category",
    xzfwbk: "Select service type",
    srfjh: "Room No.",
    sdd: "Search by Location",
    qhxq: "Campus",
    srls: "Please enter Building No. and Room No.",
    tpsc: "Upload Photos",
    wtms: "Descriptions",
    mxnyddwtjyj:
      "Describe the issues you have encountered. Please file cases seperately.",
    wjsglbmdhf: "Follow-ups on issue prefered",
    wbjsglbmdhf: `Don't Follow-ups on issue prefered`,
    xxndxyglfwgzdzc: "Many thanks for your feedback!",
    gradutegzdzc: "Many thanks for your feedback!",
    nryxsblyk:
      "Please provide a detailed description on your current situation for further actions to be taken. We assure you that every submission via this website will be deliberately assessed.",
    // ViewFeedback
    xyshfwfkxq: "Details",
    xqxx: "Info",
    fkdd: "Location",
    fktp: "Photos",
    nrms: "Description",
    blgc: "Process",
    sj: "Time",
    jd: "Stat",
    wfbl: "Denied",
    fkhf: "Reply",
    mydpj: "Satisfaction evaluation",
    my: "Satisfied",
    rk: "Accredited",
    bmy: "Unsatisfactory",
    ybj: "Completed",
    wbj: "Uncompleted",
    fhjc: "Review process",
    yfh: "Reviewed",
    hxbljg: "Extra Result",
    bljg: "Result",
    dfsj: "Time",
    dbljgjxpj: "Rate the overall satisfaction with the service",
    bypj: "No comment",
    dnlbmy: "Additional Advices?",
    msndwt: "Issue Descrip.",
    bjft: "Attached Images",
    // YouthVoice

    qsrssnr: "Please enter the content you want to search",
    ss: "Search",
    zzjz: "Loading",
    zwsj: "No data",
    xzejfl: "Please select secondary classification",
    sfnm: "Anonymous",
    cgtjfk: "You have successfully submitted feedback!",
    ydhb: "Monthly report",
    jzwc: "Load complete",
    yjddl: "It's over",
    xzxydfw: "Please select the service you want to evaluate",
    shi: "Dining",
    zhu: "Housing",
    xing: "Transportation",
    shang: "Business",
    yi: "Infirmary",
    jiaoshi: "Teacher",
    ecmyd: "Secondary satisfaction",
    zx: "Consult",
    ts: "Complaint",
    jy: "Advise",
    dz: "Praise",
    zxgg: "Latest announcement",
    mygd: "No more",
    fb: "Publish",
    ssgjchtgxgh: "Search keywords or find cards through student ID",
    ssgjc: "Search keywords(Multiple keywords are separated by Spaces)",
    xxwc:
      "The picker and the owner have completed the return offline. If you have any questions, you can contact the picker.",
    mzsm: "Disclaimers",
    zhsj: "Find time",
    sc: "Delete",
    bj: "Edit",
    sjhm: "Phone number",
    yzm: "Verification Code",
    ycctj: "You have successfully submitted feedback!",
    wpzp: "Item Photos",
    rmss: "Top Search",
    qb: "All",
    pj: "Submit",
    xysqsjh:
      "The information submitted will only be accessed and viewed by the school. For more inquiry, kindly visit feedback.sjtu.edu.cn or contact 54741234 hotline."
  }
};

// WEBPACK FOOTER //
// ./src/components/lang/en.js



// WEBPACK FOOTER //
// ./src/components/lang/en.js